import { __exports as S } from "./index455.mjs";
import { i as I } from "./index408.mjs";
import { __require as B } from "./index456.mjs";
import { __require as G } from "./index457.mjs";
import H from "./index458.mjs";
import J from "./index459.mjs";
import K from "./index460.mjs";
import Q from "./index461.mjs";
import U from "./index462.mjs";
import X from "./index463.mjs";
var y = I;
Object.defineProperty(S, "__esModule", {
  value: !0
});
var $e = S.default = de;
S.shouldForwardProp = x;
S.systemDefaultTheme = void 0;
var d = y(B()), b = y(G()), A = se(H), Y = J, Z = y(K), ee = y(Q), te = y(U), re = y(X);
const oe = ["ownerState"], ne = ["variants"], ie = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function T(e) {
  if (typeof WeakMap != "function") return null;
  var o = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (T = function(n) {
    return n ? t : o;
  })(e);
}
function se(e, o) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var t = T(o);
  if (t && t.has(e)) return t.get(e);
  var n = { __proto__: null }, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if (u !== "default" && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = f ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
function ue(e) {
  return Object.keys(e).length === 0;
}
function le(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function x(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ae = S.systemDefaultTheme = (0, te.default)(), C = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function $({
  defaultTheme: e,
  theme: o,
  themeId: t
}) {
  return ue(o) ? e : o[t] || o;
}
function fe(e) {
  return e ? (o, t) => t[e] : null;
}
function R(e, o) {
  let {
    ownerState: t
  } = o, n = (0, b.default)(o, oe);
  const f = typeof e == "function" ? e((0, d.default)({
    ownerState: t
  }, n)) : e;
  if (Array.isArray(f))
    return f.flatMap((u) => R(u, (0, d.default)({
      ownerState: t
    }, n)));
  if (f && typeof f == "object" && Array.isArray(f.variants)) {
    const {
      variants: u = []
    } = f;
    let m = (0, b.default)(f, ne);
    return u.forEach((r) => {
      let l = !0;
      typeof r.props == "function" ? l = r.props((0, d.default)({
        ownerState: t
      }, n, t)) : Object.keys(r.props).forEach((h) => {
        (t == null ? void 0 : t[h]) !== r.props[h] && n[h] !== r.props[h] && (l = !1);
      }), l && (Array.isArray(m) || (m = [m]), m.push(typeof r.style == "function" ? r.style((0, d.default)({
        ownerState: t
      }, n, t)) : r.style));
    }), m;
  }
  return f;
}
function de(e = {}) {
  const {
    themeId: o,
    defaultTheme: t = ae,
    rootShouldForwardProp: n = x,
    slotShouldForwardProp: f = x
  } = e, u = (i) => (0, re.default)((0, d.default)({}, i, {
    theme: $((0, d.default)({}, i, {
      defaultTheme: t,
      themeId: o
    }))
  }));
  return u.__mui_systemSx = !0, (i, m = {}) => {
    (0, A.internal_processStyles)(i, (a) => a.filter((p) => !(p != null && p.__mui_systemSx)));
    const {
      name: r,
      slot: l,
      skipVariantsResolver: h,
      skipSx: W,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: D = fe(C(l))
    } = m, M = (0, b.default)(m, ie), V = h !== void 0 ? h : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      l && l !== "Root" && l !== "root" || !1
    ), g = W || !1;
    let N;
    process.env.NODE_ENV !== "production" && r && (N = `${r}-${C(l || "Root")}`);
    let w = x;
    l === "Root" || l === "root" ? w = n : l ? w = f : le(i) && (w = void 0);
    const P = (0, A.default)(i, (0, d.default)({
      shouldForwardProp: w,
      label: N
    }, M)), k = (a) => typeof a == "function" && a.__emotion_real !== a || (0, Y.isPlainObject)(a) ? (p) => R(a, (0, d.default)({}, p, {
      theme: $({
        theme: p.theme,
        defaultTheme: t,
        themeId: o
      })
    })) : a, E = (a, ...p) => {
      let j = k(a);
      const _ = p ? p.map(k) : [];
      r && D && _.push((s) => {
        const c = $((0, d.default)({}, s, {
          defaultTheme: t,
          themeId: o
        }));
        if (!c.components || !c.components[r] || !c.components[r].styleOverrides)
          return null;
        const v = c.components[r].styleOverrides, O = {};
        return Object.entries(v).forEach(([L, z]) => {
          O[L] = R(z, (0, d.default)({}, s, {
            theme: c
          }));
        }), D(s, O);
      }), r && !V && _.push((s) => {
        var c;
        const v = $((0, d.default)({}, s, {
          defaultTheme: t,
          themeId: o
        })), O = v == null || (c = v.components) == null || (c = c[r]) == null ? void 0 : c.variants;
        return R({
          variants: O
        }, (0, d.default)({}, s, {
          theme: v
        }));
      }), g || _.push(u);
      const F = _.length - p.length;
      if (Array.isArray(a) && F > 0) {
        const s = new Array(F).fill("");
        j = [...a, ...s], j.raw = [...a.raw, ...s];
      }
      const q = P(j, ..._);
      if (process.env.NODE_ENV !== "production") {
        let s;
        r && (s = `${r}${(0, Z.default)(l || "")}`), s === void 0 && (s = `Styled(${(0, ee.default)(i)})`), q.displayName = s;
      }
      return i.muiName && (q.muiName = i.muiName), q;
    };
    return P.withConfig && (E.withConfig = P.withConfig), E;
  };
}
export {
  $e as default
};
